import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import {
  LoadingDataI,
  LoadingService2,
} from 'src/app/core/services/loading2.service';

@Component({
  selector: 'app-loading-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-modal.component.html',
  styleUrl: './loading-modal.component.scss',
})
export class LoadingModalComponent implements OnInit, OnDestroy {
  isOpen = true;
  loadingText = '';

  loading: LoadingDataI | null = null;
  private sub!: Subscription;

  constructor(private loadingService: LoadingService2) {}

  ngOnInit() {
    this.sub = this.loadingService.loading$.subscribe((data) => {
      this.loading = data;
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
